<template>
    <div class="wrapper-box">
        <div
            v-if="!error"
            class="result-box"
            :class="
                new Date(tesserato?.expires) < new Date() ? 'is-errored' : ''
            "
        >
            <!-- <div class="result" v-if="full">
                <div class="result_label">Nome</div>
                <div
                    :class="
                        new Date(tesserato?.expires) < new Date()
                            ? 'error_field'
                            : 'result_field'
                    "
                >
                    {{ tesserato?.firstName?.toLowerCase() }}
                </div>
            </div>
            <div class="result" v-if="full">
                <div class="result_label">Cognome</div>
                <div
                    :class="
                        new Date(tesserato?.expires) < new Date()
                            ? 'error_field'
                            : 'result_field'
                    "
                >
                    {{ tesserato?.lastName?.toLowerCase() }}
                </div>
            </div> -->

            <div class="info-box" :class="mobile ? 'pt-5' : 'pb-3'">
                <div class="result">
                    <!-- <div class="result_label is-subtle">
                        {{ $t("profile.memberships.type") }}
                    </div> -->
                    <div
                        :class="
                            new Date(tesserato?.expires) < new Date()
                                ? 'error_field'
                                : 'query_field'
                        "
                    >
                        {{
                            $i18n.locale === "en"
                                ? tesserato?.type?.nameEn
                                : tesserato?.type?.name
                        }}
                    </div>
                </div>

                <div class="result">
                    <div class="result_label is-subtle">
                        {{ $t("profile.memberships.status") }}
                    </div>
                    <div
                        :class="
                            new Date(tesserato?.expires) < new Date()
                                ? 'error_field'
                                : 'success_field'
                        "
                    >
                        {{
                            tesserato?.expires &&
                            new Date(tesserato?.expires).toLocaleDateString(
                                "it-IT",
                                {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                }
                            )
                        }}
                    </div>
                </div>
            </div>
            <b-collapse
                class="card-collapse"
                v-if="mobile === true && tesserato?.id"
                animation="slide"
                aria-id="contentIdForA11y3"
                :open.sync="open"
            >
                <template #trigger="{ open }">
                    <div
                        class="card-collapse-header"
                        role="button"
                        aria-controls="contentIdForA11y3"
                        :aria-expanded="open"
                    >
                        <p
                            class="is-size-4 m-0 has-text-weight-bold is-primary-alt card-collapse-header-title"
                        >
                            <!-- <b-icon icon="fas fa-qrcode" size="is-small" /> -->
                            {{
                                open
                                    ? $t("profile.memberships.hideQR")
                                    : $t("profile.memberships.showQR")
                            }}
                        </p>
                        <a class="card-collapse-header-icon">
                            <b-icon
                                :icon="
                                    open
                                        ? 'fas fa-chevron-up'
                                        : 'fas fa-chevron-down'
                                "
                            >
                            </b-icon>
                        </a>
                    </div>
                </template>
                <div class="hero-qrcode">
                    <qrcode-vue
                        id="qrcode"
                        v-if="tesserato?.id"
                        :value="tesserato?.id"
                        level="H"
                        foreground="rgb(110, 102, 224)"
                        background="#ffffff"
                        render-as="svg"
                        :size="this.size"
                    />
                </div>
            </b-collapse>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.card-collapse {
    .card-collapse-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 1rem;
        margin-bottom: 0;
    }
    width: 100%;
    background: var(--bg);
    border-radius: 1rem;
    // margin-top: 1rem;
}
.wrapper-box {
    // border: 1px solid var(--color-danger);
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.submit-btn {
    background: rgba(var(--bg-rgba), 0.3) !important;
    width: 100%;
    min-width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem 0 1.5rem;
    margin: 1rem 0 0 0 !important;
    align-items: center;
    .icon {
        font-size: 2rem !important;
    }
}
.error_field {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-danger);
    /* margin-bottom: 0.35rem; */
}
.info-box {
    padding: 1rem 1rem 0 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.result-box {
    /* width: 100%; */
    /* height: 100%; */
    // margin-top: 1rem;
    // width: calc(100vw - 2rem);
    // margin-top: 1rem;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    background: var(--bg);
    // padding: 2rem;
    border-radius: 1rem;
    &.is-errored {
        background: rgba(var(--color-danger-rgba), 0.35) 0%;
    }
}
.result_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-primary-alt);
    text-transform: capitalize;
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}

.query_field {
    font-size: 1.35rem;
    margin-bottom: 0.5rem;
    font-weight: 700 !important;
    color: var(--color-primary-alt);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.success_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    // color: var(--color-primary);
    color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.result > .result_field {
    text-align: center;
    font-weight: 400;
}
.result {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 1.25rem;
}
.hero-qrcode {
    animation: appear 0.5s ease-in-out;
    width: 100%;
    height: 100%;

    // min-height: 300px
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#qrcode {
    // overflow: hidden;
    padding: 2rem;
    background: white;
    border-radius: 1rem;
    // max-width: 300px !important;
    width: 100%;
    // max-width: 350px;

    // min-width: 90vw !important;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    max-height: 80vw;

    // max-width: 80vw;
    @media (min-width: 560px) {
        // max-width: 320px;
        max-height: 320px;
        // min-width: 300px !important;
        // min-height: 300px;
    }
    object-fit: contain;

    // border: 1px solid red;
}
</style>
<script>
export default {
    name: "MembershipCard",
    data() {
        return {
            size: 0,
            open: true,
        };
    },

    props: {
        mobile: {
            type: Boolean,
            default: true,
        },
        scannable: {
            type: Boolean,
            default: false,
        },
        clear: {
            type: Function,
            default: () => {},
        },

        error: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
        tesserato: {
            type: Object,
            default: () => {
                return {
                    id: "",
                    firstName: "",
                    lastName: "",
                    fiscalCode: "",
                    nationalId: "",
                    dob: "",
                    expires: "",
                };
            },
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.onResize();
        });

        window.addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        getScreenSize() {
            const width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;

            return width;
        },
        onResize() {
            this.size = this.getScreenSize();
        },
    },
};
</script>
